<div class="o-layout__row">
  <label class="o-radio" *ngFor="let item of items; let i = index">
    <input
      type="checkbox"
      value=""
      class="o-radio__input"
      (change)="changeValue(i)"
      [checked]="items[i].checked"
      *ngIf="maxSelected !== 1 && minSelected !== 1"
    />
    <input
      type="radio"
      value=""
      class="o-radio__input"
      (change)="changeValue(i)"
      [checked]="items[i].checked"
      *ngIf="maxSelected === 1 && minSelected === 1"
    />
    <div class="o-radio__label">{{ item.label | lsTranslate }}</div>
  </label>
</div>
